import { useFormContext } from "react-hook-form";

import { FormRadioGroup } from "@covertree/ui";
import { FormSelectableWithValue, ResidencyType } from "@covertree/types";

import { EffectiveDateExposureAndLapseForm } from "../validatorsAndTypes/effectiveDateExposureAndLapseForm";
import { useNewBusinessSelector } from "@covertree/new-business-redux";
import { selectIsBookConversion } from "@covertree/new-business-redux";

const getItems = (
  disabled: boolean,
  isD2C: boolean
): FormSelectableWithValue<ResidencyType>[] => [
  {
    title: "Own the home",
    value: ResidencyType.Owner,
    image: "/images/card-icons/own-home.webp",
    imageAlt: "house above a hand",
    tooltip: isD2C
      ? "I purchased the structure."
      : "Applicant purchased the structure.",
    disabled,
  },
  {
    title: "Rent the home",
    value: ResidencyType.Tenant,
    image: "/images/card-icons/rent-home.webp",
    imageAlt: "key in a house",
    tooltip: isD2C
      ? "I live in the home, but I don't own it."
      : "Applicant lives in the home, but doesn't own it.",
    disabled,
  },
];

interface ResidencyTypeRadioGroupProps {
  isD2C: boolean;
  onOptionSelect?: (option: ResidencyType) => void;
}

export function ResidencyTypeRadioGroup({
  isD2C,
  onOptionSelect,
}: ResidencyTypeRadioGroupProps) {
  const isBookConversion = useNewBusinessSelector(selectIsBookConversion);
  const { control, watch } =
    useFormContext<EffectiveDateExposureAndLapseForm>();

  const selected = watch("residencyType");

  return (
    <FormRadioGroup
      name="residencyType"
      control={control}
      selected={selected}
      direction="column"
      label={isD2C ? "" : "Does the applicant ..."}
      items={getItems(isBookConversion, isD2C)}
      onOptionSelect={(val) => {
        if (onOptionSelect) onOptionSelect(val as ResidencyType);
      }}
    />
  );
}
